// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { en } from 'vuetify/locale'; // import the default English Vuetify locale
import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput'; // Import VDateInput
import { VCalendar } from 'vuetify/labs/VCalendar'; // Import VCalendar
import * as components from 'vuetify/components'; // Import all Vuetify components
import * as directives from 'vuetify/directives'; // Import all Vuetify directives

export default createVuetify({
  components: {
    ...components, // Include all Vuetify components
    VDateInput, // Register VDateInput
    VCalendar, // Register VCalendar
  },
  directives, // Include all Vuetify directives
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2C74B3',
          secondary: '#205295',
          third: '#144272',
          fourth: '#0A2647',
          accent: '#292E1E',
        },
      },
    },
  },
  locale: {
    locale: 'en-CA',
    messages: { 'en-CA': en }, // Add fallback messages for en-CA
  },
  defaults: {
    VTextField: {
      autocomplete: 'off',
    },
    VCombobox: {
      autocomplete: 'off',
    },
    VTextarea: {
      autocomplete: 'off',
    },
    VSelect: {
      autocomplete: 'off',
    },
    VAutocomplete: {
      autocomplete: 'off',
    },
  },
});